module.exports = __webpack_public_path__ + "static/media/praca-czasowa-off.d8cabeb7.svg";